import { render, staticRenderFns } from "./ProductRfidLinkerList.vue?vue&type=template&id=1d554ae2&scoped=true&"
import script from "./ProductRfidLinkerList.vue?vue&type=script&lang=js&"
export * from "./ProductRfidLinkerList.vue?vue&type=script&lang=js&"
import style0 from "./ProductRfidLinkerList.vue?vue&type=style&index=0&id=1d554ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d554ae2",
  null
  
)

export default component.exports